import React from 'react';
import { useObservable } from 'react-use-observable';
import { transferHistoryService } from 'v2/services/transferHistory';

import ContentTable from '../ContentTable';

function TransfersTable() {
  useObservable(() => transferHistoryService.loadData(), []);

  const [entries] = useObservable(() => transferHistoryService.getTransferHistory(), [], []);
  const [pagination] = useObservable(() => transferHistoryService.getPaginationResponse(), []);
  const [isLoading] = useObservable(() => transferHistoryService.isLoading(), []);

  const handlePagination = {
    onChangeRowsPerPage: (per_page: number) => {
      transferHistoryService.setPagination({ ...pagination, ...{ per_page, current_page: 1 } });
      document.getElementById('transfers-table').scrollIntoView();
    },
    onChangePage: (page: number) => {
      transferHistoryService.setPagination({ ...pagination, ...{ current_page: page } });
      document.getElementById('transfers-table').scrollIntoView();
    },
  };

  return <ContentTable data={entries} pagination={pagination} handlePagination={handlePagination} loading={isLoading} />;
}

export default TransfersTable;
